import useB2CBasket from '@/b2c/basket/useBasket';
import basketStore from '@/shared/checkout/basket/basket.store';
import { computed } from 'vue';
import siteContextService from '@/b2c/shared/site-context.service';
import { TempStoreApiClientService } from '@/shared/product/purchase/temp-store-api';
import { AddOrUpdateModuleConfigurationRequest } from '../shared/api/server-apis';
const { addCustomerOfferItemToBasket, get } = useB2CBasket();

const isNewCheckOutEnabled = computed(() => siteContextService.isNewCheckOutEnabled);
export default function useTEMPB2CFeatureBasket() {
    const {
        quantity,
        clickAndCollectStoreId,
        hasClickAndCollectDeliverable,
        basketId,
        init,
        addRegular,
        addPickAndPack,
        addClickAndCollect,
        replaceItem,
        changeClickAndCollectStore,
        addOutletItem,
        addOrUpdateModuleConfiguration,
    } = useB2CBasket();

    const basketInitByFeature = isNewCheckOutEnabled.value ? init : basketStore.init.bind(basketStore);
    const basketIdByFeature = computed(() => isNewCheckOutEnabled.value ? basketId.value : basketStore.basket.basketId);
    const basketQuantityByFeature = computed(() => isNewCheckOutEnabled.value ? quantity.value : basketStore.quantity);
    const hasClickAndCollectByFeature = computed(() => isNewCheckOutEnabled.value ? hasClickAndCollectDeliverable.value : basketStore.basket.hasClickAndCollect);
    const clickAndCollectStoreIdByFeature = computed(() => isNewCheckOutEnabled.value ? clickAndCollectStoreId.value : basketStore.pickupStoreId);

    const addRegularByFeature = async(sku: string, quantity: number, relatedItemId?: number) => {
        return isNewCheckOutEnabled.value ? await addRegular({ sku, quantity, relatedItemId }) : await basketStore.add(sku, quantity);
    };

    const addPickAndPackByFeature = async(sku: string, quantity: number, relatedItemId?: number) => {
        return isNewCheckOutEnabled.value ? await addPickAndPack({ sku, quantity, relatedItemId }) : await basketStore.addPickAndPack(sku, quantity);
    };

    const addClickAndCollectByFeature = async(sku: string, quantity: number, clickAndCollectStoreId: string, relatedItemId?: number) => {
        return isNewCheckOutEnabled.value ? await addClickAndCollect({ sku, quantity, clickAndCollectStoreId, relatedItemId }) : await basketStore.addClickAndCollect(sku, quantity, clickAndCollectStoreId);
    };

    const replaceItemByFeature = async(lineItemId: string, targetSku: string) => {
        return isNewCheckOutEnabled.value ? await replaceItem({ lineItemId, targetSku }) : await basketStore.replaceItem(lineItemId, targetSku);
    };

    const changeClickAndCollectStoreByFeature = async(storeId: string, sku: string = '') => {
        return isNewCheckOutEnabled.value ? await changeClickAndCollectStore(storeId) : await TempStoreApiClientService.clickAndCollectChangeStore(storeId, sku);
    };

    const addOutletItemByFeature = async(recId: number, messageId: string) => {
        return isNewCheckOutEnabled.value ? await addOutletItem({ recId }, messageId) : await basketStore.addOutletItem(recId, messageId);
    };

    const getByFeature = async() => {
        return isNewCheckOutEnabled.value ? await get() : await basketStore.get();
    };

    const addCustomerOfferItemToBasketByFeature = async(customerOfferId: string | null, customerOfferLineItemIds: string[]) => {
        if (isNewCheckOutEnabled.value) {
            return await addCustomerOfferItemToBasket(customerOfferId, customerOfferLineItemIds);
        } else {
            if (customerOfferId) {
                if (customerOfferLineItemIds.length === 1) {
                    await basketStore.addOfferItem(customerOfferId, customerOfferLineItemIds[0]);
                } else {
                    await basketStore.addOffer(customerOfferId);
                }
            }
        }
    };

    const addOrUpdateModuleConfigurationByFeature = async(configurationId: string, moduleConfiguratorTileData: AddOrUpdateModuleConfigurationRequest) => {
        return isNewCheckOutEnabled.value ? await addOrUpdateModuleConfiguration(configurationId, moduleConfiguratorTileData) : await basketStore.addOrUpdateModuleConfiguration(configurationId, moduleConfiguratorTileData);
    };

    return {
        init: basketInitByFeature,
        basketId: basketIdByFeature,
        basketQuantity: basketQuantityByFeature,
        addRegular: addRegularByFeature,
        addPickAndPack: addPickAndPackByFeature,
        addClickAndCollect: addClickAndCollectByFeature,
        replaceItem: replaceItemByFeature,
        hasClickAndCollect: hasClickAndCollectByFeature,
        clickAndCollectStoreId: clickAndCollectStoreIdByFeature,
        changeClickAndCollectStore: changeClickAndCollectStoreByFeature,
        addOutletItem: addOutletItemByFeature,
        get: getByFeature,
        addCustomerOfferItem: addCustomerOfferItemToBasketByFeature,
        addOrUpdateModuleConfiguration: addOrUpdateModuleConfigurationByFeature,
    };
}
